import { useEffect, useState } from "react"
import { CountDown } from "./register/CountDown"
import { Link } from "react-router-dom"
import { tracking } from "../utils/tracking"
import { svgs } from "../assets/svgs"

export const DiscountPopup = () => {

    const deadline = new Date('August 04 2023 00:00:00 PST')
    const currDate = new Date()
    const DISCOUNT = deadline > currDate ? 400 : 300

    const [isOpen, setIsOpen] = useState(false)

    useEffect(() => {
        setTimeout(() => {
            setIsOpen(true)
        }, 10 * 1000)
    }, [])

    if (sessionStorage.getItem('DPopup')) return <></>
    if (deadline < currDate) return <></>
    if (!isOpen) return <></>
    return (
        <div className='discount-popup'>
            <button onClick={() => { setIsOpen(false); tracking(352); sessionStorage.setItem('DPopup', '1') }}>{svgs.closeExe}</button>
            <h1>Early-Bird Sale</h1>
            <h2>Save $<span>{DISCOUNT}!</span></h2>
            <h3>On all tickets!</h3>
            <CountDown deadline={deadline} />
            <section>
                <Link onClick={() => { setIsOpen(false); tracking(351); sessionStorage.setItem('DPopup', '1') }} className='btn b2' to={'registration'}>REGISTER NOW</Link>
                <div>{svgs.logoFrame}</div>
            </section>
        </div>
    )
}

